import {
  CheckboxGroup as ChakraCheckboxGroup,
  CheckboxGroupProps as ChakraCheckboxGroupProps,
} from "@chakra-ui/react";
import type { CheckboxGroupSharedProps } from "./CheckboxGroup.props";

export default function CheckboxGroup({
  onChange,
  onValueChange,
  value,
  defaultValue,
  ...props
}: CheckboxGroupProps): JSX.Element {
  return (
    <ChakraCheckboxGroup
      onValueChange={(details: { value: string[] }) => {
        // Map v3's onValueChange to v1/v2's onChange
        const newValue = Array.isArray(details)
          ? details
          : details?.value ?? [];
        if (onChange) {
          onChange(newValue);
        }
        onValueChange?.(newValue);
      }}
      value={value}
      defaultValue={defaultValue}
      {...props}
    />
  );
}

export type CheckboxGroupProps = CheckboxGroupSharedProps &
  ChakraCheckboxGroupProps;
